<template>
  <div class="el-container">
    <img @load="handleImgLoad()" class="nesc_nd1_li" :src="require('../../assets/image/home/honor_bg.jpg')" />
<!--    <div :class="{show: textShow, en: lang === 'en'}" class="flex-column-left text-content">-->
<!--      <h1>{{ $t('lang.companyProfile') }}</h1>-->
<!--      <div>{{ $t('lang.companyProfileInfo') }}</div>-->
<!--    </div>-->
    <div class="honor-list pc">
      <div class="flex-row-center">
        <img :src="require('../../assets/image/home/honor1.jpg')" />
        <img :src="require('../../assets/image/home/honor2.jpg')" />
      </div>
      <div class="flex-row-center">
        <img :src="require('../../assets/image/home/honor3.jpg')" />
        <img :src="require('../../assets/image/home/honor4.jpg')" />
        <img :src="require('../../assets/image/home/honor5.jpg')" />
      </div>
    </div>
    <div class="honor-list phone">
      <img :src="require('../../assets/image/home/honor1.jpg')" />
      <img :src="require('../../assets/image/home/honor2.jpg')" />
      <img :src="require('../../assets/image/home/honor3.jpg')" />
      <img :src="require('../../assets/image/home/honor4.jpg')" />
      <img :src="require('../../assets/image/home/honor5.jpg')" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CompanyHonors',
  components: {
  },
  data: () => {
    return {
      lang: '',
      textShow: false
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    const lang = window.sessionStorage.getItem('language')
    this.lang = lang
  },
  updated() {},

  destroyed() {},

  methods: {
    handleImgLoad() {
      this.textShow = true
    }
  }
}
</script>

<style lang="scss">
//.el-main {
//  height: auto !important;
//  display: block;
//  @media screen and (max-width: 993px) {
//    min-height: calc(100vh - 60px) !important;
//  }
//  @media screen and (max-width: 767px) {
//    min-height: calc(100vh - 60px) !important;
//  }
//}
</style>
<style scoped lang="scss">
.el-container {
  position: relative;
}
.nesc_nd1_li {
  position: relative;
  height: calc(100vh - 64px);
  @media screen and (max-width: 992px) {
    height: auto;
  }
}
.nesc_list_png {
  width: 100%;
  height: 100%;
}
.honor-list {
  &.pc {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    div {
      margin-top: 30px;
      img {
        padding-left: 30px;
      }
    }
    display: none;
  }
  &.phone {
    display: none;
    justify-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 30px;
    margin-bottom: 30px;
    img {
      margin-top: 20px;
    }
  }
  @media screen and (min-width: 993px) {
    &.pc {
      display: block;
    }
    &.phone {
      display: none;
    }
  }
  @media screen and (max-width: 992px) {
    &.pc {
      display: none;
    }
    &.phone {
      display: flex;
    }
  }
}

</style>
